import { apiClient } from "@/config/api.config";

export const authService = {
  register: async (userData) => {
    try {
      const response = await apiClient.post("/auth/register", userData);
      return response.data;
    } catch (error) {
      if (error.response?.data) {
        throw error.response.data;
      }
      throw new Error("Registration failed");
    }
  },

  verifyMobile: async (verificationData) => {
    try {
      const response = await apiClient.post(
        "/auth/verify-mobile",
        verificationData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Mobile verification failed"
      );
    }
  },

  forgotPassword: async (data) => {
    try {
      const response = await apiClient.post("/auth/forgot-password", data);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Failed to request password reset"
      );
    }
  },

  verifyPasswordResetOTP: async (data) => {
    try {
      const response = await apiClient.post("/auth/verify-reset-otp", data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to verify OTP");
    }
  },

  resetPassword: async (data) => {
    try {
      const response = await apiClient.post("/auth/reset-password", data);
      return response.data;
    } catch (error) {
      const errMessage =
        error.response?.data?.message || "Failed to reset password";

      return {
        status: "error",
        message: errMessage,
        success: false,
      };
    }
  },

  requestEmailChange: async (newEmail) => {
    try {
      const response = await apiClient.post("/auth/request-email-change", {
        newEmail,
      });
      return response.data;
    } catch (error) {
      const errMessage =
        error.response?.data?.message || "Failed to request email change";

      return {
        status: "error",
        message: errMessage,
        success: false,
      };
    }
  },

  verifyEmailChange: async (data) => {
    try {
      const response = await apiClient.post("/auth/verify-email-change", data);
      return response.data;
    } catch (error) {
      const errMessage =
        error.response?.data?.message || "Failed to verify email change";

      return {
        status: "error",
        message: errMessage,
        success: false,
      };
    }
  },

  completeEmailChange: async (data) => {
    try {
      const response = await apiClient.post(
        "/auth/complete-email-change",
        data
      );
      return response.data;
    } catch (error) {
      const errMessage =
        error.response?.data?.message || "Failed to complete email change";

      return {
        status: "error",
        message: errMessage,
        success: false,
      };
    }
  },

  sendMobileOtp: async (mobile) => {
    try {
      const response = await apiClient.post("/auth/send-mobile-otp", {
        mobile,
      });
      return response.data;
    } catch (error) {
      throw error.response
        ? error.response.data
        : new Error("Mobile verification failed");
    }
  },

  singleverifyMobile: async (verificationData) => {
    try {
      const response = await apiClient.post(
        "/auth/verify-singlemobile-otp",
        verificationData
      );
      return response.data;
    } catch (error) {
      throw error.response
        ? error.response.data
        : new Error("Mobile verification failed");
    }
  },

  login: async (loginData) => {
    try {
      const response = await apiClient.post("/auth/login", loginData);

      if (response.data?.token) {
        const token = response.data.token;
        const user = response.data.user;

        localStorage.setItem("authToken", token);
        localStorage.setItem("user", JSON.stringify(user));

        return user.role;
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Login failed");
    }
  },

  adminCreateEntity: async (userData) => {
  try {
    const response = await apiClient.post("/admin/create-entity", userData);
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : new Error("Entity creation failed");
  }
},

  getCurrentUser: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  verifyLoginOTP: async (data) => {
    try {
      const response = await apiClient.post("/auth/verify-login-otp", data);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "OTP verification failed"
      );
    }
  },

  googleAuth: async (googleData) => {
    try {
      const response = await apiClient.post("/auth/google", googleData);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || "Google authentication failed"
        );
      }
      throw new Error("Google authentication failed. Please try again.");
    }
  },

  getProfile: async () => {
    try {
      const response = await apiClient.get("/auth/profile");
      return response.data;
    } catch (error) {
      throw error.response
        ? error.response.data
        : new Error("Failed to fetch profile");
    }
  },

  setToken: (token) => {
    if (token) {
      localStorage.setItem("authToken", token);
      return true;
    }
    return false;
  },

  getToken: () => {
    return localStorage.getItem("authToken");
  },

  clearToken: () => {
    localStorage.removeItem("authToken");
  },

  updateProfile: async (kycId, userData) => {
    try {
      const response = await apiClient.put(`/auth/update/${kycId}`, userData);
      return response.data;
    } catch (error) {
      throw error.response
        ? error.response.data
        : new Error("Failed to update profile");
    }
  },

  getKycProfile: async () => {
    try {
      const response = await apiClient.get("/auth/kyc/userprofile");
      return response.data;
    } catch (error) {
      throw error.response
        ? error.response.data
        : new Error("Failed to fetch profile");
    }
  },
};
